// extracted by mini-css-extract-plugin
export default {"label":"Label_label__eeogc","line":"Label_line__B1Ndg","primary":"Label_primary__yZl1G"};